import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import api, { formatDetail } from "@/lib/api";
import { formatTime12 } from "@/lib/i18n";

export default function TrashPage() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/admin/trash"); setItems(data); };
  useEffect(() => { load(); }, []);
  const restore = async (id) => { try { await api.post(`/admin/bookings/${id}/restore`); toast.success("Restored"); load(); } catch (e) { toast.error(formatDetail(e.response?.data?.detail)); } };
  return (
    <AdminLayout title="Trash" showTurnBoard={false}>
      <div className="bg-white rounded-2xl border border-zen-border overflow-hidden">
        <table className="w-full">
          <thead className="bg-zen-surface text-xs uppercase text-zen-muted"><tr>
            <th className="text-left px-5 py-3">Customer</th><th className="text-left px-5 py-3">Date</th><th className="text-left px-5 py-3">Reason</th><th className="text-right px-5 py-3">Actions</th>
          </tr></thead>
          <tbody>
            {items.map((b) => (
              <tr key={b.id} className="border-t border-zen-border" data-testid={`trash-row-${b.id}`}>
                <td className="px-5 py-4"><div className="font-medium">{b.customer_name}</div><div className="text-xs text-zen-muted">{b.customer_phone}</div></td>
                <td className="px-5 py-4 text-sm">{b.date} · {formatTime12(b.start_time)}</td>
                <td className="px-5 py-4 text-sm text-zen-muted">{b.cancel_reason || "—"}</td>
                <td className="px-5 py-4 text-right"><Button size="sm" variant="outline" onClick={() => restore(b.id)} className="rounded-full" data-testid={`restore-${b.id}`}><RotateCcw className="w-3 h-3 mr-1" /> Restore</Button></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="4" className="text-center py-12 text-zen-muted">Trash is empty</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
